import React from 'react';

/** Perforace filmového pásu – vizuální podpis aplikace. Sdílené napříč sekcemi. */
export default function FilmStrip({ holes = 28 }) {
  return (
    <div className="film-strip" aria-hidden="true">
      {Array.from({ length: holes }).map((_, i) => (
        <span className="film-strip__hole" key={i} />
      ))}
    </div>
  );
}
